import React, { FunctionComponent, PropsWithChildren } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import * as OrbModal from '@yandex-360/orb-components/dist/components/Modal2';
import { Text } from '@yandex-360/orb-components/dist/components/Text';

import css from './styles.css';

interface OrbModalConfirmBaseProps extends Pick<OrbModal.ModalProps, 'zIndex' | 'onClose' | 'scope'> {
    title: string;
    titleLineLimit?: number;
    confirmLabel: string;
    cancelLabel?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    withContentWrapper?: boolean;
}

export type OrbModalConfirmProps = PropsWithChildren<OrbModalConfirmBaseProps>;

export const OrbModalConfirm: FunctionComponent<OrbModalConfirmProps> = ({
    title,
    titleLineLimit,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    children,
    withContentWrapper = true,
    ...modalProps
}) => {
    return (
        <OrbModal.Modal size="md" {...modalProps} visible>
            <OrbModal.NavigationBar title={title} closable titleLineLimit={titleLineLimit} />
            <OrbModal.Slot>
                {withContentWrapper ? (
                    <Text testId="confirm-modal-content" className={css.description}>
                        {children}
                    </Text>
                ) : (
                    children
                )}
            </OrbModal.Slot>
            <OrbModal.ActionBar>
                {cancelLabel && (
                    <Button view="neutral" onPress={onCancel}>
                        {cancelLabel}
                    </Button>
                )}
                <Button view="brand" testId="confirm-modal-confirm-button" onPress={onConfirm}>
                    {confirmLabel}
                </Button>
            </OrbModal.ActionBar>
        </OrbModal.Modal>
    );
};
